export default __webpack_public_path__ + "static/logo-tim-kramer-photography-35fba9caa0a29f12a626b0dd4a46a111.webp";